export enum PrivacyNoticeBlockKind {
  PARAGRAPH = 'paragraph',
  SUBHEADING = 'subheading',
  LIST = 'list',
  CONTACT = 'contact'
}

export type PrivacyNoticeBlock =
  | { kind: PrivacyNoticeBlockKind.PARAGRAPH; text: string }
  | { kind: PrivacyNoticeBlockKind.SUBHEADING; text: string }
  | { kind: PrivacyNoticeBlockKind.LIST; items: string[] }
  | { kind: PrivacyNoticeBlockKind.CONTACT; email: string }

export type PrivacyNoticeSection = {
  title: string
  blocks: PrivacyNoticeBlock[]
}

export type PrivacyNotice = {
  /** ISO date of this text, stored on the user when they acknowledge it */
  version: string
  lastUpdated: string
  introduction: PrivacyNoticeBlock[]
  sections: PrivacyNoticeSection[]
}

export type PrivacyNoticeTextRun = {
  text: string
  isEmphasized: boolean
}
